<div class="animationComponent">
    <div id="image" class="visible"  >
        <img class="realImage" [src]="imageUrl" alt="" fallback="../../assets/logo/local_thumbnail.png">
    </div>
    <div id="animation" class="visible" >
        <img id="animationImage" [src]="animationUrl" alt="">
    </div>   
    
</div>